export class SvgElementBuilder {
  containerElement!: HTMLElement;
  objectElement?: HTMLObjectElement;
  svg?: HTMLElement;

  async load(url: string, styleSheet?: string, documentStyles?: any): Promise<void> {

    const element = document.createElement("div");
    element.className = "hhds-map-svgmarker";
    element.innerHTML = `<object type="image/svg+xml" data="${url}"></object>`;
    element.style.visibility = "hidden";

    const objectElement = element.querySelector("object");
    this.containerElement = element;
    this.objectElement = objectElement as HTMLObjectElement;

    // document.body.appendChild(element);

    return new Promise((resolve) => {
      
      objectElement?.addEventListener("load", () => {

        const svg = objectElement.contentDocument;
        if (!svg) return;
        if (styleSheet) {
          const style = svg.createElementNS("http://www.w3.org/2000/svg", "style");
          style.setAttribute("type", "text/css");
          style.textContent = styleSheet;
          svg.documentElement?.appendChild(style);

          documentStyles &&
            Object.keys(documentStyles).forEach((key) => {
              svg.documentElement.style.setProperty(key, documentStyles[key]);
            });
          //svg.documentElement.style.transform = "scale(0.3)";
        }
        element.style.opacity = "0.0";
        requestAnimationFrame(() => {
          element.style.visibility = "visible";
          element.style.transition = "opacity 0.6s ease-in-out";
          element.style.opacity = "1.0";
        });

        this.svg = svg.documentElement;

      });

      resolve();

    });
  }
}
